import { CoilSheet, Graph } from "./coilSheet";

export class Utility {

  static startingRecord(pageNum: number, pageSize: number): number {
    return (pageNum * pageSize) + 1;
  }

  static lastRecord(pageNum: number, pageSize: number , totalRecordOnPage: number): number {
    return (pageNum * pageSize) + totalRecordOnPage;
  }

  static formatDate(date: Date | undefined) {
    if (date) {
      return date?.toString()?.split('-')?.reverse()?.join('-');
    } else {
      return '';
    }
  }

  static convertToGraph(dataSet: string): Graph {
    return  JSON.parse(dataSet);
  }

  static mapArrayToIndexedValues(array?: number[]): [number, number][] {
    const mappedArray: [number, number][] = [];
    if (array) {
      array.forEach((value, index) => {
        mappedArray.push([index, Number(value)]);
      });
    }
  
    return mappedArray;
  }

  static mapArrayToIndexedValuesUS(array?: number[]): [number, number][] {
    const mappedArray: [number, number][] = [];
    if (array) {
      array.forEach((value, index) => {
        index = this.convertMeterToFeet(index);
        value = this.convertMicrometerToMil(value);
        mappedArray.push([index, Number(value)]);
      });
    }
  
    return mappedArray;
  }

  // Method to get the selected coils to compare from localStorage
  static getSelectedCoilsFromLocalStorage(): CoilSheet[] {
    const selectedCoilsJson = localStorage.getItem('storageSelectedCoils');
      if (selectedCoilsJson) {
      return JSON.parse(selectedCoilsJson);
    }
    return [];
  }

  // Method to set the selected coils to compare from localStorage
  static setselectedCoilsToLocalStorage(selectedCoils: CoilSheet[]): void {
    const selectedCoilsJson = JSON.stringify(selectedCoils);
    localStorage.setItem('storageSelectedCoils', selectedCoilsJson);
  }

  // Method to convert meter to feet
   static convertMeterToFeet(value: number): any {
    if(value==null){
      const metertoFeetnull = null;
      return metertoFeetnull;
    }else{
      const metertoFeet = value * 3.281;
      return +metertoFeet.toFixed(2);
    }
    
  }

  // Method to convert millimeter to inch
  static convertMillimeterToInch(value: number): any {
    if(value==null){
      const valuetoinchnull = null;
      return valuetoinchnull;
    }else{
      const valuetoinch = (value / 25.4);
      return +valuetoinch.toFixed(3);
    }
   
  }

  // Method to convert micrometer to mm
  static convertMicrometerToMil(value: number): any {
    if(value==null){
      const microToMIllinull = null;
      return microToMIllinull;
    }else{
      const microToMIlli = value /1000
      return +microToMIlli.toFixed(3);
    }

  }

  // Method to convert MPa to psi
  static convertMpaToPsi(value: number): number {
    return Math.round(value * 145.038 * 100) / 100;
  }

  // Method to convert millimeter to inch
  static convertEUTonToUSTon(value: number): number {
    return Math.round(value * 1.10231 * 100) / 100;
  }

  //set company in localstorge

  static setCompanySelected(value:any){
localStorage.setItem("company",value);
  }
  static getCompanySelected(){
    localStorage.getItem("company");
      }
  
}

